import { DatePicker, Button, Space } from "antd";
const { RangePicker } = DatePicker;

const DateRangeFilter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
  return (
    <div className="d-flex gap-2 flex-column" style={{ padding: 8 }}>
      <RangePicker
        value={selectedKeys.length ? selectedKeys : null}
        onChange={(dates) => {
          if (dates && dates.length === 2) {
            //  keep dayjs ONLY
            setSelectedKeys(dates);
          } else {
            setSelectedKeys([]);
          }
        }}
      />

      <Space className="d-flex justify-content-between w-100" style={{ marginTop: 8 }}>
        <Button
          size="small"
          onClick={() => {
            clearFilters();
            confirm();
          }}
        >
          Reset
        </Button>
        <Button size="small" type="primary" onClick={() => confirm()}>
          Apply
        </Button>
      </Space>
    </div>
  );
};

export default DateRangeFilter;
